import PropTypes from 'prop-types';
import React from 'react';
import PriorityIcon from "../../priority/priority-icon/priority-icon";


export default function PillPriority(props) {

    const onClick = (e) => {
        e.stopPropagation()
        // console.log("on click", props.value)
        if (props.onClick) props.onClick(props.value)
    }

    const onDelete = (e) => {
        e.stopPropagation()
        // console.log("on delete", props.value)
        if (props.onDelete) props.onDelete(props.value)
    }


    const classes = Classes(
        'ui5-pill-u', 'gray',
        's-'+props.size,
        props.className
    );

    return (
        <div className={classes} onClick={onClick}>
            <PriorityIcon className="icon" priority={props.priority}/>
            <div className="pill-label">{gd.company.priorities['priority'+props.priority]}</div>
            {props.onDelete && <div className="i5-close" onClick={onDelete} />}
        </div>
    )
}


PillPriority.propTypes = {
    size        : PropTypes.oneOf([26, 22]),

    palette     : PropTypes.oneOf(['gray']),
    color       : PropTypes.number,

    label       : PropTypes.string,
    icon        : PropTypes.string,

    // callbacks
    onClick     : PropTypes.func,
    onDelete    : PropTypes.func,       // if set adds delete button
    value       : PropTypes.any,       // this is what being passed when we set on click or on delete !!!

    classes     : PropTypes.any,
    style       : PropTypes.any,

    // Special cases
    priority    : PropTypes.number.isRequired,     // if passes - display icon & label automatically
}

PillPriority.defaultProps = {
    size        : '26'
}
